import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subject, fromEvent, merge, timer } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'environment/environment';
import { minutesToMilliseconds } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class InactivityService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private readonly inactivityTime = minutesToMilliseconds(60);
  protected authService = inject(AuthService);
  public events = ['mousemove', 'mousedown', 'keydown', 'click', 'scroll'];

  public startInactivityTracking(): void {
    const activityEvents$ = merge(...this.events.map((event) => fromEvent(document, event)));

    activityEvents$
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => timer(this.inactivityTime))
      )
      .subscribe(() => {
        this.logout();
      });
  }

  private logout(): void {
    console.log("logout after inactivity");
    sessionStorage.removeItem('refreshFlagger');
    this.stopInactivityTracking();
    this.authService.logout({
      logoutParams: {
        returnTo: environment.auth0RedirectUrl,
      },
    });
  }

  public stopInactivityTracking(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public ngOnDestroy(): void {
    this.stopInactivityTracking();
  }
}
